module.exports = __webpack_public_path__ + "static/media/eng-popup-step4.9de1ad45.png";